import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import toast from "react-hot-toast";
import { useSchoolParentApi } from "../../../../../utils/useSchoolParentApi";

export const ParentEditKid = ({ showModal, handleQuestClose, kid }) => {
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;
  const [password, setPassword] = useState("");
  const [confirm_password, setConfirmPassword] = useState("");
  const [passwordmatch, setpasswordmatch] = useState(true);
  const [passwordValid, setPasswordValid] = useState(true);
  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    if (regex.test(newPassword)) {
      setPasswordValid(true);
    }
    if (confirm_password && newPassword === confirm_password) {
      setpasswordmatch(true);
    }
  };

  const { apiCall } = useSchoolParentApi();

  const handleConfirmPasswordChange = (e) => {
    const confirmPasswordValue = e.target.value;
    setConfirmPassword(confirmPasswordValue);

    if (confirmPasswordValue === password) {
      setpasswordmatch(true);
    }
  };
  const handleSubmit = async () => {
    let valid = true;
    setPasswordValid(true);
    setpasswordmatch(true);

    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

    if (!passwordRegex.test(password)) {
      setPasswordValid(false);
      valid = false;
    }

    if (password !== confirm_password) {
      setpasswordmatch(false);
      valid = false;
    }

    if (!valid) return;

    try {
      const response = await apiCall(`${apiUrl}/parent/update-kid/${kid.id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ password, confirm_password }),
      });

      if (!response?.message) {
        toast.error("Failed to update kid.");
        return;
      }

      toast.success(response.message);
      setTimeout(handleQuestClose, 2000);
    } catch (error) {
      toast.error("An error occurred. Please try again.");
    }
  };

  return (
    <>
      <Modal show={showModal} onHide={handleQuestClose} centered>
        <div className="modalHeader">
          <Modal.Header closeButton></Modal.Header>
        </div>
        <Modal.Body>
          <div>
            <form>
              <div className="mb-3">
                <label htmlFor="password" className="form-label">
                  New Password
                </label>
                <div className="position-relative">
                  <input
                    type={showCurrentPassword ? "text" : "password"}
                    className={`form-control ${
                      !passwordValid ? "is-invalid no-validation-icon" : ""
                    }`}
                    id="password"
                    onChange={handlePasswordChange}
                    value={password}
                  />
                  <span
                    className="position-absolute top-50 translate-middle-y"
                    style={{ right: "15px", cursor: "pointer" }}
                    onClick={() =>
                      setShowCurrentPassword((prevState) => !prevState)
                    }
                  >
                    <i
                      className={`fa ${
                        showCurrentPassword ? "fa-eye" : "fa-eye-slash"
                      }`}
                    ></i>
                  </span>
                </div>
                {!passwordValid && (
                  <div className="invalid-feedback d-block">
                    Password must be at least 8 characters long and contain at
                    least one uppercase letter, one lowercase letter, one
                    number, and one special character.
                  </div>
                )}
              </div>
              <div className="mb-3">
                <label htmlFor="confirm_password" className="form-label">
                  Confirm Password
                </label>
                <div className="position-relative">
                  <input
                    type={showNewPassword ? "text" : "password"}
                    className={`form-control ${
                      !passwordmatch ? "is-invalid no-validation-icon" : ""
                    }`}
                    id="confirm_password"
                    onChange={handleConfirmPasswordChange}
                    value={confirm_password}
                  />
                  <span
                    className="position-absolute top-50 translate-middle-y"
                    style={{ right: "15px", cursor: "pointer" }}
                    onClick={() =>
                      setShowNewPassword((prevState) => !prevState)
                    }
                  >
                    <i
                      className={`fa ${
                        showNewPassword ? "fa-eye" : "fa-eye-slash"
                      }`}
                    ></i>
                  </span>
                </div>
                {!passwordmatch ? (
                  <div className="invalid-feedback d-block">
                    Passwords do not match
                  </div>
                ) : null}
              </div>
            </form>
            <Button
              className="btn btn-primary mt-4 w-100"
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </div>
        </Modal.Body>
      </Modal>{" "}
    </>
  );
};
